/* eslint-disable array-bracket-newline */
import { IProfile, enums } from '@kattana-io/common';
import { IFeaturesState } from '../reducers/features';

const commonPricingPlan = (expiresAt: string): IFeaturesState => ({
  currentPlan: enums.PricingPlan.common,
  expiresAt,
  features: {
    priceAlerts: 5,
    tokenUnlocks: false,
    timeframeExcludes: ['S', 's'],
    uniswapLiquidity: false,
  },
});

const premiumPricingPlan = (expiresAt: string): IFeaturesState => ({
  currentPlan: enums.PricingPlan.premium,
  expiresAt,
  features: {
    priceAlerts: undefined,
    tokenUnlocks: true,
    timeframeExcludes: [],
    uniswapLiquidity: true,
  },
});

const getFeaturesForPricingPlan = (pricingPlan: IProfile): IFeaturesState => {
  switch (pricingPlan.vip_id) {
  case enums.PricingPlan.common:
    return commonPricingPlan(pricingPlan.validity_at);
  case enums.PricingPlan.premium:
    return premiumPricingPlan(pricingPlan.validity_at);
  default:
    return commonPricingPlan(pricingPlan.validity_at);
  }
};

const filterTimeframes = (timeframes: string[], excludes: string[]) => {
  return timeframes.filter((t) => {
    const includesSymbol = t.split('').some((char) => excludes.includes(char));
    return !includesSymbol;
  });
};

const dex = [
  { caption: 'Seconds', intervals: ['1 s', '5 s', '10 s'] },
  { caption: 'Minutes', intervals: ['1 m', '3 m', '5 m', '15 m', '30 m'] },
  { caption: 'Hours', intervals: ['1 h', '2 h', '4 h', '6 h', '8 h', '12 h'] },
];

const cex = [
  { caption: 'Small intervals', intervals: ['1 m', '5 m', '15 m', '30 m'] },
  { caption: 'Large intervals', intervals: ['1 h', '1 d', '1 w'] },
];

const getModalTimeframs = (excludes: string[]) => {
  if (excludes.includes('S') || excludes.includes('s')) {
    return {
      dex: [dex[1], dex[2]],
      cex,
    };
  }
  if (excludes.includes('M') || excludes.includes('m')) {
    return {
      dex: [dex[0], dex[2]],
      cex: [cex[1]],
    };
  }

  return { cex, dex };
};

export {
  commonPricingPlan,
  premiumPricingPlan,
  getFeaturesForPricingPlan,
  filterTimeframes,
  getModalTimeframs,
};
